import { z } from 'zod';

export const AnnotationEditorDialogSchema = z.object({
  layer: z.string(),
  image: z.string(),
  group: z.string(),
});

export type AnnotationEditorDialog = z.infer<typeof AnnotationEditorDialogSchema>;

export const LinkEditorDialogSchema = z.object({
  type: z.union([z.literal('internal'), z.literal('external')]),
  href: z.union([z.string().startsWith('/node/'), z.string().url()]),
  targetBlank: z.boolean()
})

export type LinkEditorDialog = z.infer<typeof LinkEditorDialogSchema>;


export const AnnotationLinkEditorDialogSchema = z.object({
  linkText: z.string(),
});

export type AnnotationLinkEditorDialog = z.infer<typeof AnnotationLinkEditorDialogSchema>;